namespace distill.datasets.views.rows {

    class InitArgs {
        datasetId: string = appn.emptyString;
        updateUrl: string = appn.emptyString;
        pkColumns: string[] = [];
        canEdit: boolean = false;
        lastUpdatedColumnName: string = appn.emptyString;
        columnTypes: { [key: string]: string } = {};
        requiredColumns: string[] = [];
        maxLengths: { [key: string]: number | null } = {};
        columns: { data: number, title: string, sortable: boolean }[] = [];
    }

    let _args: InitArgs;
    let _datatable: any;

    export function init(args: InitArgs) {
        _args = args;
        createDataTable();
    }

    function createDataTable() {
        _datatable = appn.dataTable.create('#rows-grid', {
            sAjaxSource: '../RowsDataTable',
            aaSorting: [[1, 'asc']],
            bServerSide: true, bProcessing: true, scrollX: '100%', scrollY: '70vh', ordering: true, colResize: false,
            fnServerData: (data: any[]) => { data.push({ name: 'sCustom_0', value: _args.datasetId }); },
            fnInitComplete: function() {
                const $filter = $('.dataTables_filter');

                const $resetBtn = $(appn.dataTable.FILTER_RESET_BTN);
                $filter.append($resetBtn);
                appn.dataTable.addSearchPlaceholder();

                $resetBtn.on('click', function(e: Event) {
                    e.preventDefault();
                    $filter.find('input').val('');

                    const dataTable = ($('#rows-grid') as any).DataTable();
                    dataTable.search('').draw();
                });
            },
            editable: {
                entityId: _args.datasetId,
                updateUrl: _args.updateUrl,
                pkColumns: _args.pkColumns,
                canEdit: _args.canEdit,
                lastUpdatedColumnName: _args.lastUpdatedColumnName,
                columnTypes: _args.columnTypes,
                requiredColumns: _args.requiredColumns,
                maxLengths: _args.maxLengths,
                columns: _args.columns
            }
        });
    }
}
